import { CobaltButton } from '@cae/cobalt-react/components/button';
import * as React from 'react';

import type { TileSelectionSectionProps } from './TileSelectionSection.types';

import styles from './TileSelectionSection.module.css';

const TileSelectionSection = React.memo(
  ({
    title,
    dataTestId,
    children,
    selectedCount = 0,
    totalCount = 0,
    onSelectAll,
    onDeselectAll,
    showSelectAll = true,
  }: Readonly<TileSelectionSectionProps>): React.ReactElement | null => {
    if (React.Children.count(children) === 0) return null;

    const allSelected = totalCount > 0 && selectedCount === totalCount;

    const renderSelectButton = (): React.ReactElement | null => {
      if (!showSelectAll) return null;
      if (allSelected && onDeselectAll) {
        return (
          <CobaltButton variant="ghost" size="small" onClick={onDeselectAll}>
            Deselect All
          </CobaltButton>
        );
      }
      if (onSelectAll) {
        return (
          <CobaltButton variant="ghost" size="small" onClick={onSelectAll}>
            Select All
          </CobaltButton>
        );
      }
      return null;
    };

    return (
      <section className={styles.tileSelectionSection} data-testid={dataTestId}>
        <header className={`body-01 ${styles.tileSelectionSectionHeader}`}>
          <h4 className="heading-01">{title}</h4>
          <div className={styles.tileSelectionSectionHeaderActions}>
            {selectedCount > 0 && (
              <p className={styles.tileSelectionSectionSelected}>
                ({selectedCount} selected)
              </p>
            )}
            {renderSelectButton()}
          </div>
        </header>
        <div className={styles.tileSelectionSectionList}>{children}</div>
      </section>
    );
  }
);

TileSelectionSection.displayName = 'TileSelectionSection';

export { TileSelectionSection };
